import ResourceApi from '../ResourceApi';

const Confluence = {
  posts: async (params = {}) => (await ResourceApi.get('/resource/confluence/posts', params)).data,
  item: async (id, params = {}) => (await ResourceApi.get(`/resource/confluence/posts/${id}`, params)).data,
};

export default Confluence;
